import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { L10N_LOCALE, L10nLocale, L10nTranslationService } from 'angular-l10n';
import { AlertSettings, FeatureLayerSettings, MunicipalCity } from 'src/app/hickory-api';

@Component({
  selector: 'app-recipient-details-cities',
  templateUrl: './recipient-details-cities.component.html',
  styleUrls: ['./recipient-details-cities.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false
})
export class RecipientDetailsCitiesComponent {
  readonly locale = inject<L10nLocale>(L10N_LOCALE);
  private readonly translation = inject(L10nTranslationService);

  @Input() alert: AlertSettings;

  onCityClick(_item: MunicipalCity) {
    // no-op
  }

  getLayerRecipientCount(layer: FeatureLayerSettings): string {
    const count = layer.Count ?? 0;
    return count > 0 ? "" + count : this.translation.translate('None');
  }
}
